export const features = ()=> {
    let featuresScrollTrigger

    const sections = document.querySelectorAll('.features')

    sections?.forEach(section=> {

        const wrapper = section.querySelector('.features__wrapper')
        const wrapperElement = section.querySelector('.features__wrapper-element')

        const featuresFunc = ()=> {
            if (featuresScrollTrigger) {
                featuresScrollTrigger.kill();
            }

            featuresScrollTrigger = ScrollTrigger.create({
                trigger: wrapper,
                start: 'top 65%',
                end: 'bottom 10%',
                onEnter: () => {
                    wrapperElement.classList.add('play');
                },
                onLeaveBack: () => {
                    wrapperElement.classList.remove('play');
                },
            });

        }


        featuresFunc()

        window.addEventListener('resize',featuresFunc)
    })
}